/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateMarketplaceItemListingRequest } from '../../models/create-marketplace-item-listing-request';
import { CreateMarketplaceItemListingResponse } from '../../models/create-marketplace-item-listing-response';

export interface MarketplaceServiceCreateMarketplaceItemListing$Params {
      body: CreateMarketplaceItemListingRequest
}

export function marketplaceServiceCreateMarketplaceItemListing(http: HttpClient, rootUrl: string, params: MarketplaceServiceCreateMarketplaceItemListing$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateMarketplaceItemListingResponse>> {
  const rb = new RequestBuilder(rootUrl, marketplaceServiceCreateMarketplaceItemListing.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateMarketplaceItemListingResponse>;
    })
  );
}

marketplaceServiceCreateMarketplaceItemListing.PATH = '/api/v3/gateway/marketplace/listing';
